import { render, staticRenderFns } from "./IncFooter.vue?vue&type=template&id=02eca970&scoped=true&"
import script from "./IncFooter.vue?vue&type=script&lang=js&"
export * from "./IncFooter.vue?vue&type=script&lang=js&"
import style0 from "./IncFooter.vue?vue&type=style&index=0&id=02eca970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02eca970",
  null
  
)

export default component.exports